export default "__VITE_ASSET__7d6fc3fe__"